<template>
  <transition name="modal-fade">
    <div v-if="isVisible" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <!-- Background backdrop -->
      <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity backdrop-blur-sm" @click="closeModal"></div>

      <div class="flex items-center justify-center min-h-screen p-4 text-center sm:p-0">
        <div class="relative bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:max-w-4xl sm:w-full border border-gray-100">
          
          <!-- Close button -->
          <button @click="closeModal" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none z-10 transition-colors">
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div class="grid grid-cols-1 md:grid-cols-2">
            <!-- Pro Version (Recommended) -->
            <div class="relative bg-gradient-to-br from-blue-600 to-indigo-700 p-8 md:p-10 text-white overflow-hidden group cursor-pointer hover:shadow-inner" @click="goToPro">
              <!-- Decorative background elements -->
              <div class="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 rounded-full bg-white opacity-10 blur-2xl transform group-hover:scale-110 transition-transform duration-700"></div>
              <div class="absolute bottom-0 left-0 -ml-16 -mb-16 w-40 h-40 rounded-full bg-blue-400 opacity-20 blur-xl"></div>
              
              <div class="relative z-10 flex flex-col h-full justify-between">
                <div>
                  <div class="inline-flex items-center px-3 py-1 rounded-full bg-yellow-400 bg-opacity-20 border border-yellow-300 border-opacity-30 text-yellow-200 text-xs font-bold uppercase tracking-wider mb-6 backdrop-blur-md">
                    <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                    官方推荐 · 商用首选
                  </div>
                  
                  <h3 class="text-3xl font-extrabold mb-2 tracking-tight">无界云机</h3>
                  <p class="text-blue-100 text-lg mb-6 font-light">商业化完整方案 (uni.yisur.cn)</p>
                  
                  <ul class="space-y-3 mb-8">
                    <li class="flex items-center text-blue-50">
                      <svg class="w-5 h-5 mr-3 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
                      全套源码交付 (PC+H5+APP)
                    </li>
                    <li class="flex items-center text-blue-50">
                      <svg class="w-5 h-5 mr-3 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
                      WebRTC 超低延迟 & 无限扩容
                    </li>
                    <li class="flex items-center text-blue-50">
                      <svg class="w-5 h-5 mr-3 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
                      1对1专属技术服务 & 优先更新
                    </li>
                  </ul>
                </div>

                <div class="mt-4">
                  <a href="http://uni.yisur.cn" target="_blank" class="block w-full text-center bg-white text-blue-700 font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl hover:bg-blue-50 transition-all duration-300 transform hover:-translate-y-1">
                    前往 Pro 版官网
                    <span class="block text-xs font-normal text-blue-500 mt-1">uni.yisur.cn</span>
                  </a>
                </div>
              </div>
            </div>

            <!-- Demo Version -->
            <div class="relative bg-gray-50 p-8 md:p-10 flex flex-col justify-between">
              <div>
                <div class="inline-flex items-center px-3 py-1 rounded-full bg-gray-200 text-gray-500 text-xs font-bold uppercase tracking-wider mb-6">
                  基础版
                </div>
                
                <h3 class="text-2xl font-bold text-gray-700 mb-2">体验/基础/完整版</h3>
                <p class="text-gray-500 text-base mb-6">基础商业化方案 (yisur.nouz.cn)</p>
                
                <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6 rounded-r-md">
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                      </svg>
                    </div>
                    <div class="ml-3">
                      <p class="text-sm text-yellow-700 font-medium">
                        注意：支持商业化运营，但功能相对基础。
                      </p>
                    </div>
                  </div>
                </div>
                
                <ul class="space-y-3 mb-8 text-gray-500 text-sm">
                  <li class="flex items-center">
                    <svg class="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    仅支持 WebSockets 协议
                  </li>
                  <li class="flex items-center">
                    <svg class="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    基础技术支持 & 1年更新
                  </li>
                  <li class="flex items-center">
                    <svg class="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    有限的窗口数量授权
                  </li>
                </ul>
              </div>

              <div class="mt-4">
                <a href="http://yisur.nouz.cn" target="_blank" class="block w-full text-center bg-white border-2 border-gray-200 text-gray-500 font-semibold py-3 px-6 rounded-xl hover:border-gray-300 hover:text-gray-700 transition-colors">
                  查看基础版演示
                  <span class="block text-xs font-normal text-gray-400 mt-1">yisur.nouz.cn</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { useVersionModal } from '../composables/useVersionModal';

const { isVisible, closeModal } = useVersionModal();

const goToPro = () => {
  window.open('http://uni.yisur.cn', '_blank');
  closeModal();
};
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
